<template>
  <div class="OffCanvas">
    <!-- 按钮触发器， 需要指定 target -->
    <p class="header">
      <i @click="OffCanvasOpen()" class="am-icon-reorder am-fl"></i>
      <router-link :to="{ name: 'index'}" class="index am-fr"></router-link>
    </p>
    <p class="footer">
      <router-link :to="{ name: 'lxts', params: { nr: 'lxwm' }}" class="lxwm"></router-link>
    </p>
    <!-- 侧边栏内容 -->
    <div id="dh-OffCanvas" class="am-offcanvas">
      <div class="am-offcanvas-bar">
        <div class="am-offcanvas-content am-panel-group" id="accordion">
          <div class="meun" :class="{ active: $route.name=== 'index'}">
            <i class="index icon"></i>
            <span class="title">
              <router-link :to="{ name: 'index'}">首页</router-link>
            </span>
            <hr/>
          </div>
          <div class="meun">
            <i class="tzzjy icon"></i>
            <span class="title" @click="ListClose('#tzzjylist')">投资者教育</span>
            <hr/>
          </div>
          <div id="tzzjylist" class="am-panel-collapse am-collapse zklist">
            <div class="zk_meun" v-for="(item,key,index) in tzzjytitle" :key="key"
                 :class="{ active: $route.path=== '/tzzjy/'+key}">
              <router-link :to="{ name: 'tzzjy', params: { nr: key }}">{{item}}</router-link>
            </div>
          </div>
          <div class="meun">
            <i class="xxgs icon"></i>
            <span class="title" @click="ListClose('#xxgslist')">信息公示</span>
            <hr/>
          </div>
          <div id="xxgslist" class="am-panel-collapse am-collapse zklist">
            <div class="zk_meun" v-for="(item,key,index) in xxgstitle" :key="key"
                 :class="{ active: $route.path=== '/xxgs/'+key}">
              <router-link :to="{ name: 'xxgs', params: { nr: key }}">{{item}}</router-link>
            </div>
          </div>
          <div class="meun" :class="{ active: $route.path=== '/lxts/lxwm'}">
            <i class="lxwm icon"></i>
            <span class="title">
              <router-link :to="{ name: 'lxts', params: { nr: 'lxwm' }}">联系我们</router-link>
            </span>
            <hr/>
          </div>
          <div class="meun" :class="{ active: $route.name=== 'yjfk'}">
            <i class="yjfk icon"></i>
            <span class="title">
              <router-link :to="{ name: 'yjfk'}">意见反馈</router-link>
            </span>
            <hr/>
          </div>
          <div class="meun" :class="{ active: $route.path=== '/lxts/tsjy'}">
            <i class="tsjy icon"></i>
            <span class="title">
              <router-link :to="{ name: 'lxts', params: { nr: 'tsjy' }}">投诉建议</router-link>
            </span>
            <hr/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import title from '@/common/title/title'
  export default {
    name: 'OffCanvas',
    data () {
      return {
        tzzjytitle: title.tzzjytitle,
        xxgstitle: title.xxgstitle
      }
    },
    methods: {
      ListClose: function (target) {
        $('#tzzjylist').collapse('close')
        $('#xxgslist').collapse('close')
        setTimeout(function () {
          $(target).collapse('open')
        }, 100)
      },
      OffCanvasOpen: function () {
        $('#dh-OffCanvas').offCanvas({effect: 'push'})
        $('#dh-OffCanvas').offCanvas('open')
      }
    },
    mounted: function () {
      $('#tzzjylist').collapse()
      $('#xxgslist').collapse()
      if (this.$route.name !== 'xxgs') {
        setTimeout(function () {
          $('#xxgslist').collapse('close')
        }, 300)
      }
      if (this.$route.name !== 'tzzjy') {
        setTimeout(function () {
          $('#tzzjylist').collapse('close')
        }, 300)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/common.styl"
  .OffCanvas
    height 44px
    .am-offcanvas-content
      a
        color inherit
    .footer
      position fixed
      right 15px
      bottom  15px
      color #4f6fc0
      z-index 9999
      .lxwm
        line-height 44px
        bg-image('浮标', 76px, 76px)
    .header
      margin 0 0 0 0
      height 44px
      .index
        margin-top 13px
        bg-image('首页-首页', 24px, 22px)
    .am-icon-reorder:before
      margin-top: 13px
      font-size 25px
    .am-offcanvas-bar
      width 164px
      background-color #222742
      padding-top 44px
      .am-offcanvas-content
        padding-left 0
        text-align left
        color $font_color2
        font-size 17px
        .meun
          width 164px
          padding-left 16px
          hr
            margin 0
            border-top: solid 1px #363c5b
          .icon
            margin-top 13.5px
            margin-right  5px
          .index
            bg-image('首页icon', 20px, 18px)
          .tzzjy
            bg-image('投资者教育icon', 20px, 18px)
          .xxgs
            bg-image('信息公示icon', 20px, 18px)
          .lxwm
            bg-image('联系我们icon', 20px, 18px)
          .yjfk
            bg-image('意见反馈icon', 20px, 18px)
          .tsjy
            bg-image('投诉建议icon', 20px, 18px)
          &.active
            background-color #0f132b
        .zklist
          border-left: 6px solid #3d9ebe
          margin-top -44px
          padding-top 44px
          .zk_meun
            margin-left 39px
            border-bottom: solid 1px #363c5b
            &.active
              background-color #0f132b
              position relative
              &:before
                position absolute
                background-color #0f132b
                content ""
                height 44px
                width 164px
                left -36px
                z-index -1
</style>



// WEBPACK FOOTER //
// OffCanvas.vue?60c26c9c